import { useEffect, useState, useCallback } from "react";
import "../assets/songList.css";

const resourceExists = async (url) => {
    try {
        const response = await fetch(url, {
            method: "HEAD",
        });

        return (
            response.status === 200 &&
            response.headers.get("Content-Type") !== "text/html; charset=utf-8"
        );
    } catch (error) {
        console.error("Error checking resource:", error);
        return false;
    }
};

function BarVolume({ volume }) {
    return (
        <div className="wrapper-volume">
            <div
                className="volume-level"
                style={{ width: `${volume ? volume * 100 : 70}%` }}
            ></div>
        </div>
    );
}

function SongItem({ song, onSongUpdate }) {
    const [resourceAvailable, setResourceAvailable] = useState(null);
    const [editedSong, setEditedSong] = useState(song);

    useEffect(() => {
        onSongUpdate(editedSong);
    }, [editedSong]);

    useEffect(() => {
        resourceExists(song.musicSrc).then((exists) => {
            setResourceAvailable(exists);
        });
    }, [song.musicSrc]);

    return (
        <div className={`song-item ${!resourceAvailable && "brokenLink"}`}>
            <h3>
                <input
                    type="text"
                    value={editedSong.name}
                    onChange={(e) =>
                        setEditedSong({ ...editedSong, name: e.target.value })
                    }
                />{" "}
                -
                {resourceAvailable === null ? (
                    <small> Vérification en cours...</small>
                ) : resourceAvailable ? (
                    <small className="green"> ✓</small>
                ) : (
                    <small className="red"> ❌</small>
                )}
            </h3>
            <p>
                Auteur :{" "}
                <input
                    type="text"
                    value={editedSong.singer}
                    onChange={(e) =>
                        setEditedSong({ ...editedSong, singer: e.target.value })
                    }
                />
            </p>
            <p>
                Volume : <BarVolume volume={song.volumeSonore} />
            </p>
        </div>
    );
}

function SongList({ songs }) {
    const [arrayOfSongs, setArrayOfSongs] = useState(songs);

    const handleSongUpdate = useCallback(
        (index, updatedSong) => {
            const newSongs = [...arrayOfSongs];
            newSongs[index] = updatedSong;
            setArrayOfSongs(newSongs);
        },
        [arrayOfSongs]
    );

    return (
        <div className="song-list">
            <strong>Pour construire une nouvelle playlist (ligne de commande) : </strong>
            <pre><code>npm run buildPlaylist</code></pre>
            <br />
            <strong>Pour vous aider a renommer les fichiers musicaux (ligne de commande) :</strong>
            <pre><code>npm run namingSongs</code></pre>
            {songs.map((song, index) => (
                <SongItem
                    key={index}
                    song={song}
                    onSongUpdate={(updatedSong) => handleSongUpdate(index, updatedSong)}
                />
            ))}
            <pre>
                <code>{JSON.stringify(arrayOfSongs, null, 2)}</code>
            </pre>
        </div>
    );
}

export default SongList;
